angular.module('tf.controllers')

    .controller('ShareManagerUsersController', ['$scope','ShareService', 'FarmService',
        function ($scope, ShareService, FarmService) {


            $scope.remove = function(user){
                ShareService.unshareUser(user).then(function(){
                    removeUser(user);
                });

            };

            function removeUser(user){
                for (var i = 0; i < $scope.users.length; i++) {
                    if($scope.users[i]._id === user._id){
                        $scope.users.splice(i,1);
                    }
                }
            }

            function initFarm(){
                FarmService.getFarm().then(function(farm){
                    $scope.farm = farm;
                    $scope.users = farm.users;
                });
            }

            initFarm();


        }])

    .controller('ShareManagerFoldersController', ['$scope','ShareService','User',
        function ($scope, ShareService, User) {
            //$scope.user = new User(data.user);
            //$scope.folders = data.folders;

            $scope.remove = function(folder){
                ShareService.unshareFolder(folder).then(function(){
                    removeFolder(folder);
                });

            };

            function removeFolder(folder){
                for (var i = 0; i < $scope.folders.length; i++) {
                    if($scope.folders[i]._id === folder._id){
                        $scope.folders.splice(i,1);
                    }
                }
            }

            function initFarm(){
                FarmService.getFarm().then(function(farm){
                    $scope.farm = farm;
                    $scope.user = new User(_farm.users);
                });
            }

            initFarm();



        }])
;